import { passkeyClient } from "@better-auth/passkey/client";
import { createAuthClient } from "better-auth/react";

import { addBreadcrumb } from "@/lib/client/breadcrumbs";

export const authClient = createAuthClient({
    plugins: [
        passkeyClient(),
    ],
    fetchOptions: {
        // Better-Auth client-side errors (sign-in 401, passkey verify
        // failures, session refresh issues) flow through this hook.
        // We push a breadcrumb so the next system_logs entry has the
        // auth context, and forward 5xx into a system-log entry.
        onError: async (ctx) => {
            const status = ctx.response?.status ?? 0;
            const url = ctx.request?.url ?? '';
            const path = (() => {
                try {
                    return new URL(String(url)).pathname || '<unknown>';
                } catch {
                    return '<unknown>';
                }
            })();
            const message = ctx.error?.message ?? `auth ${status}`;
            addBreadcrumb({
                category: 'auth',
                message: `${path} → ${status}: ${message.slice(0, 80)}`,
                data: { status, path },
            });

            // Server-side auth issues (5xx) deserve a system-log entry;
            // 4xx is normal user error and stays as a breadcrumb only.
            if (status >= 500 && typeof window !== 'undefined') {
                try {
                    await fetch('/api/system-logs', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            level: 'ERROR',
                            message: `Auth client error: ${path} → ${status}`,
                            context: { type: 'auth.client_error', path, status, message },
                        }),
                        keepalive: true,
                    });
                } catch {
                    // best-effort
                }
            }
        },
    },
});
